const agnicoEagle = {
  itemDescription: 'Item Description',
  itemNumber: 'Item Number',
  purchaseOrderNumber: 'PO Number',
};

export default agnicoEagle;
